import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import CatalogItemImage from 'rebook/apps/catalog/components/CatalogItemImage';
import pluralize from 'rebook/apps/utils/text/pluralize';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import CatalogItem from 'rebook/apps/catalog/components/CatalogItem';
import * as CatalogFreeIndexActions from 'rebook/apps/catalog/actions/CatalogFreeIndexActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import { Niche } from 'rebook/apps/catalog/models';
import BackLink from 'rebook/apps/base/components/BackLink';
import { URLS } from 'rebook/apps/base/constants';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import styles from './style.scss';


const NicheItem = ({ niche }) => {
  const theNiche = new Niche(niche);

  return (
    <li className={styles.item}>
      <Link to={theNiche.getFreeBookListLink()} className={styles.card}>
        <CatalogItem
          imageSrc={niche.image}
          count={niche.free_book_count}>
          <div className="title-3">{niche.name}</div>
        </CatalogItem>
      </Link>
    </li>
  );
};

const NicheList = ({ niches, freeBooksCounter }) => (
  <div className={styles.container}>
    <BackLink link={URLS.catalogIndex}>
      Жанры
    </BackLink>
    <div className={styles.freeBookIcon}>
      <div className="sectionHeader">
        <h1>Бесплатные книги</h1>
      </div>
      <div>
        <Link to={URLS.catalogFreeBookList} className="link">
          {numberWithSpace(freeBooksCounter)} {pluralize(freeBooksCounter, 'книга', 'книги', 'книг')}
        </Link>
      </div>
      <div className={styles.freeBookIconImage}>
        <CatalogItemImage />
      </div>
    </div>
    <ul className={styles.list}>
      {niches && niches.length > 0 && (
        niches.map((item) => (
          <NicheItem niche={item} key={item.id} />
        ))
      )}
    </ul>
  </div>
);

class CatalogFreeIndexView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(CatalogFreeIndexActions.fetchInitialData(match));
  }

  componentDidMount() {
    this.props.CatalogFreeIndexActions.fetchInitialData();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  render() {
    const { niches } = this.props.catalogFreeIndex;
    const { booksPerSubscriptionCounter } = this.props;

    if (!niches) {
      return <SpinnerLoader />;
    }

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          <NicheList niches={niches} freeBooksCounter={booksPerSubscriptionCounter.free} />
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    catalogFreeIndex: state.catalogFreeIndex,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    CatalogFreeIndexActions: bindActionCreators(CatalogFreeIndexActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogFreeIndexView);
